import { render, staticRenderFns } from "./MediaZh.vue?vue&type=template&id=1c84c003&scoped=true&"
import script from "./MediaZh.vue?vue&type=script&lang=js&"
export * from "./MediaZh.vue?vue&type=script&lang=js&"
import style0 from "./MediaZh.vue?vue&type=style&index=0&id=1c84c003&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84c003",
  null
  
)

export default component.exports